/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DnR API
 * 地方自治体事業管理システムAPI
 * OpenAPI spec version: 1.0.0
 */
import { faker } from '@faker-js/faker';
import type { RequestHandlerOptions } from 'msw';
import { delay, HttpResponse, http } from 'msw';
import type { JobsExecutionDetailResponse, PagedJobsExecutionListResponse } from './model';
import { JobsExecutionOperationType, JobsExecutionStatus, JobsExecutionTargetType } from './model';

export const getListExecutionsResponseMock = (): PagedJobsExecutionListResponse => ({
  ...{ count: faker.number.int({ min: undefined, max: undefined }) },
  ...{
    items: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(
      () => ({
        id: faker.string.uuid(),
        target_type: faker.helpers.arrayElement(Object.values(JobsExecutionTargetType)),
        target_name: faker.string.alpha({ length: { min: 10, max: 20 } }),
        operation_type: faker.helpers.arrayElement(Object.values(JobsExecutionOperationType)),
        status: faker.helpers.arrayElement(Object.values(JobsExecutionStatus)),
        start_at: `${faker.date.past().toISOString().split('.')[0]}Z`,
        end_at: faker.helpers.arrayElement([
          faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, null]),
          undefined,
        ]),
        target_id: faker.helpers.arrayElement([
          faker.helpers.arrayElement([faker.string.uuid(), null]),
          undefined,
        ]),
        error: {
          code: faker.string.alpha({ length: { min: 10, max: 20 } }),
          domain: faker.string.alpha({ length: { min: 10, max: 20 } }),
          domain_code: faker.string.alpha({ length: { min: 10, max: 20 } }),
          message: faker.string.alpha({ length: { min: 10, max: 20 } }),
        },
      }),
    ),
  },
});

export const getGetExecutionResponseMock = (): JobsExecutionDetailResponse => ({
  id: 'e1000001-0000-0000-0000-000000000001',
  target_type: 'assessments',
  target_name: 'テスト比較',
  operation_type: 'create',
  status: 'completed',
  start_at: '2024-03-01T10:00:00Z',
  end_at: '2024-03-01T10:05:00Z',
  target_id: '04000001-0000-0000-0000-000000000001',
  error: { code: '', domain: '', domain_code: '', message: '' },
});

export const getListExecutionsMockHandler = (
  overrideResponse?:
    | PagedJobsExecutionListResponse
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<PagedJobsExecutionListResponse> | PagedJobsExecutionListResponse),
  options?: RequestHandlerOptions,
) => {
  return http.get(
    '*/jobs/executions',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getListExecutionsResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};

export const getGetExecutionMockHandler = (
  overrideResponse?:
    | JobsExecutionDetailResponse
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<JobsExecutionDetailResponse> | JobsExecutionDetailResponse),
  options?: RequestHandlerOptions,
) => {
  return http.get(
    '*/jobs/executions/:executionId',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getGetExecutionResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};
export const getDnRAPIMock = () => [getListExecutionsMockHandler(), getGetExecutionMockHandler()];
